module.exports = __webpack_public_path__ + "img/button-arrows-white.9f83ff5e.svg";